import { render, staticRenderFns } from "./CombinationsProductSlotRow.vue?vue&type=template&id=e2be0cfc&scoped=true"
import script from "./CombinationsProductSlotRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./CombinationsProductSlotRow.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CombinationsProductSlotRow.vue?vue&type=style&index=0&id=e2be0cfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2be0cfc",
  null
  
)

export default component.exports